var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.store.getters.isNotEcosystemOrPremium)?_c(_setup.AddTracker,{ref:"addTrackerModal",on:{"trackerSaved":_setup.trackerCreated}}):_vm._e(),_c(_setup.SimilarStartups,{ref:"similarStartupsModal",attrs:{"type":"search"}}),_c(_setup.StartChatPopup,{ref:"startChatModal",attrs:{"contactsType":"ecosystem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }